import { Threshold } from 'bluetooth/thresholds';

const inRange = ([low, high]: [number, number]) => (value: number): boolean =>
  value >= low && value <= high;

const checkThreshold = (compareAgainst: Threshold[]) => (toCheck: number[]): boolean =>
  compareAgainst.every(({ max, min }, index) => inRange([min, max])(toCheck[index]));

export default checkThreshold;
